import moment from 'moment';

const date = new Date();
export const year = date.getUTCFullYear();
const month = date.getUTCMonth() + 1;
const formattedMonth = month >= 10 ? month : '0' + month;

export const startDate = `${year}-01`;
export const endDate = `${year}-${formattedMonth}`;

export const periodAsQueryParam = (
  date: Record<string, number | string | null>,
) => {
  const dateToArray = Object.values(date).filter(Boolean) as number[];
  return moment(dateToArray).format(
    'yyyy-MM' + (dateToArray.length > 2 ? '-DD' : ''),
  );
};

export const disabledDate = () => {
  return {
    disabledDate: (date: Date) => date.getFullYear() < 2023,
  };
};
